import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { CommissionSetting } from "../../modules/commissionSetting/components/CommissionSetting";
import { Status404 } from "../../modules/statusPage/component/Status404";
export const CommissionSettingContext = createContext({});

export const CommissionSettingWrapper = () => {
  const value = {};

  return (
    <CommissionSettingContext.Provider value={value}>
      <Routes>
        <Route path="" element={<CommissionSetting />} />
        <Route path="*" element={<Status404 />} />
      </Routes>
    </CommissionSettingContext.Provider>
  );
};
